var _path, _path2, _ellipse, _path3, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDelayed = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.121,
    height: 14.312,
    viewBox: "0 0 19.121 14.312",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.394,284.212l-4.615-7.993a1.434,1.434,0,0,0-2.484,0l-4.615,7.993a1.434,1.434,0,0,0,1.242,2.152h9.23a1.434,1.434,0,0,0,1.242-2.152Zm-.6,1.09a.738.738,0,0,1-.646.373h-9.23a.745.745,0,0,1-.646-1.118l4.615-7.993a.746.746,0,0,1,1.291,0l4.615,7.993A.738.738,0,0,1,259.8,285.3Z",
    transform: "translate(-241.985 -272.552)",
    fill: "#ff9d00",
    stroke: "#ff9d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.821,329.793a.271.271,0,0,0-.271.271v3.481a.271.271,0,1,0,.543,0v-3.481A.271.271,0,0,0,372.821,329.793Z",
    transform: "translate(-360.05 -323.424)",
    fill: "#ff9d00",
    stroke: "#ff9d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.252,
    cy: 0.252,
    rx: 0.252,
    ry: 0.252,
    transform: "translate(12.5 11.17)",
    fill: "#ff9d00",
    stroke: "#ff9d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.687,258.261v-1.918a.343.343,0,1,0-.687,0v2.06a.343.343,0,0,0,.1.243l1.03,1.03a.343.343,0,0,0,.486-.485Z",
    transform: "translate(-380.103 -253.981)",
    fill: "#ff9d00",
    stroke: "#ff9d00",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ff9d00",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 3.75,
    fill: "none"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelayed, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delayed.90754345.svg";
export { ForwardRef as ReactComponent };